/* eslint-disable no-debugger */
import { Injectable } from '@angular/core';
import { environment } from '@/environments/environment';
import axios from 'axios';
import { NewAccessionData } from '@/app/interfaces/new-accession-data';
import { ToastService } from './script/toast.service';
import { LoaderService } from '@/app/services/interceptor/loader-service';
import { ValidateAdhesionResponse, CreateAdhesionParams } from '@/app/interfaces/new-accession-data';

@Injectable({
  providedIn: 'root',
})
export class NewAdhesionService {
  private readonly apiUrl = '/api/aurora';

  constructor(
    private toastService: ToastService,
    private loader: LoaderService
  ) {}

  async validateAdhesion(params: NewAccessionData): Promise<ValidateAdhesionResponse> {
    try {
      this.loader.show();
      const data = {
        name: params.name,
        destination: params.destination,
        protocolId: params.protocol.id,
        serviceId: params.service.id,
        type: params.type,
        range: params.range,
        date: params.date,
        title: params.title,
        url: params.url,
        effectiveDate: params.effectiveDate,
        rpts: params.rpts.map((el) => el.jobCode),
        observation: params.observation,
      };
      const response = await axios.post<ValidateAdhesionResponse>(
        `${environment.url}${this.apiUrl}/validar_adhesion`,
        data,
        {
          withCredentials: true,
        }
      );
      return response.data;
    } catch (error) {
      this.toastService.showError('Error al validar la adhesión', error?.message || 'Ha ocurrido un error inesperado');
      throw error;
    } finally {
      this.loader.hide();
    }
  }

  async createAdhesion(params: CreateAdhesionParams): Promise<unknown> {
    try {
      this.loader.show();
      const response = await axios.post(`${environment.url}${this.apiUrl}/guardar_adhesion`, params, {
        withCredentials: true,
      });
      this.toastService.showSuccess('Adhesión creada', 'La adhesión se ha guardado correctamente');
      return response.data;
    } catch (error) {
      this.toastService.showError('Error al guardar la adhesión', error?.message || 'Ha ocurrido un error inesperado');
      throw error;
    } finally {
      this.loader.hide();
    }
  }
}
